import { Component, OnInit, ViewChild } from '@angular/core';
import { WebConstants } from 'src/app/util/web.constants';
import { PaymentDetailSearchService } from 'src/app/services/payment-detail-search';
import { ExcelExportDataService } from 'src/app/excelService/excel-export-data.service';
import { first } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Router } from "@angular/router";
import { OrganizationService } from 'src/app/services/organization.service';
import { LprDataService } from 'src/app/services/lpr-data.service';
import { UserService } from 'src/app/services/user.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { GeofenceService } from 'src/app/services/geofence.service';
import { BaseChartDirective, Color } from 'ng2-charts';
import { Chart } from 'chart.js';
import { AuthenticationService } from "src/app/services/authentication.service";
import { DomSanitizer } from '@angular/platform-browser';
import { TokenStorage } from 'src/app/util/token.storage';
import * as moment from 'moment';
import { element } from 'protractor';

@Component({
  selector: 'app-dashboard-super',
  templateUrl: './dashboard-super.component.html',
  styleUrls: ['./dashboard-super.component.scss']
})

export class DashboardSuperComponent implements OnInit {

  @ViewChild(BaseChartDirective)
  public chart: BaseChartDirective; // Now you can reference your chart via `this.chart`
  public chartDonutMulti: any;
  public chartDonutLpn: any;
  public chartLine: any;

  public title: string = WebConstants.MENU_NAMES.DASHBOARD_SUPER;
  public userRole: any;
  public allOrgsData: any = [];
  public allGeofenceData: any;
  public allOrgsStatistics: any;

  public allPeoUsers: any;
  public peoDataByOrgForMulti: any;
  public peoDataByOrgForAllGeofence: any;

  public selectedOrgIdMonthly: any;
  public selectedOrgIdDaily: any;
  public selectedOrgIdMulti: any;
  public selectedOrgIdAllGeofence: any;
  public selectedOrgIdByLpn: any;
  public selectedOrgIdByPeoLastShift: any;

  public selectedOrgStatsDataMonthly: any;
  public selectedOrgStatsDataDaily: any;
  public selectedOrgStatsDataMulti: any;
  public selectedOrgStatsDataAllGeofence: any;
  public selectedOrgStatsDataByLpn: any;
  public selectedOrgStatsDataByPeoLastShift: any;

  public selectedDateMonthly:         {start, end} = {start:moment().subtract(6, 'days'), end:moment()};
  public selectedDateDaily:           {start, end} = {start:moment().subtract(6, 'days'), end:moment()};
  public selectedDateMulti:           {start, end} = {start:moment().subtract(6, 'days'), end:moment()};
  public selectedDateAllGeofence:     {start, end} = {start:moment().subtract(6, 'days'), end:moment()};
  public selectedDateByLpn:           {start, end} = {start:moment().subtract(6, 'days'), end:moment()};

  public chartNameMonthly =       "Monthly Statistics";
  public chartNameDaily =         "Daily Statistics";
  public chartNameAllGeofence =   "All Geofence Statstics";
  public chartNamePeoLastShift =  "PEO Last Shift Statistics";
  public chartNameMulti =         "Multi Parameter Statistics";
  public chartNameLpn =           "License Plate Statistics";

  public licensePlate: any;
  public selectedGeofenceId: any;
  public selectedPeoIdForMulti: any;
  public selectedPeoIdForAllGeofence: any;

  public currentDate: any = new Date();
  public currentYear: any = this.currentDate.getFullYear();
  public passportData: any;
  public paymentData: any;
  public disabledToggle: boolean = false;
  public checkedToggle: boolean = true; 
  
  public barChartColorsScan: Color[] = [ 
    { backgroundColor: 'green' }
  ]

  public barChartColorsViolation: Color[] = [
    { backgroundColor: 'red' }
  ]

  public myoption = {
    tooltips: { enabled: true },
    hover: { animationDuration: 1 },
    animation: {
    duration: 1,
    onComplete: function () {
      var chartInstance = this.chart,
        ctx = chartInstance.ctx;
        ctx.textAlign = 'center';
        // ctx.fillStyle = "rgba(255, 255, 255, 1)";
        ctx.textBaseline = 'bottom';
        this.data.datasets.forEach(function (dataset, i) {
          var meta = chartInstance.controller.getDatasetMeta(i);
          meta.data.forEach(function (bar, index) {
            var data = dataset.data[index];
            ctx.fillText(data, bar._model.x, bar._model.y - 5);
          });
        });
      }
    }
  };

  public chartData: any = [];
  public barChartType = 'bar';
  public barChartLegend = true;
  public barChartOptions = {
    scaleShowVerticalLines: false,
    responsive: true
  };

  // public stackedBarChartOptions: any = {
  //   scaleShowVerticalLines: false,
  //   responsive: true,
  //   scales: {
  //           xAxes: [{
  //               stacked: true
  //           }],
  //           yAxes: [{
  //               stacked: true
  //           }]
  //       }
  // };

  // public barChartLabelsScans = [];
  // public barChartLabelsViolations = [];
  // public barChartDataScans = [
  //   {data: [], label: 'Total Scans'},
  // ];
  // public barChartDataViolations = [
  //   {data: [], label: 'Total Violations'},
  // ];



  // public barChartLabelsMulti = [];
  // public barChartDataMulti = [
  //   {data: [], label: 'Shifts'},
  //   {data: [], label: 'Scans'},
  //   {data: [], label: 'Violations'},
  // ];



  public barChartLabelsMonthly = [];
  public barChartDataMonthly = [
    {data: [], label: 'Shifts'},
    {data: [], label: 'Scans'},
    {data: [], label: 'Permitted'},
    {data: [], label: 'Authorized'},
    {data: [], label: 'Expired'},
    {data: [], label: 'Unauthorized'},
    {data: [], label: 'Unpaid'} 
  ];

  public barChartLabelsDaily = [];
  public barChartDataDaily = [
    {data: [], label: 'Shifts'},
    {data: [], label: 'Scans'},
    {data: [], label: 'Permitted'},
    {data: [], label: 'Authorized'},
    {data: [], label: 'Expired'},
    {data: [], label: 'Unauthorized'},
    {data: [], label: 'Unpaid'} 
  ];


  public barChartLabelsAllGeofence = [];
  public barChartDataAllGeofence = [
    {data: [], label: 'Shifts'},
    {data: [], label: 'Scans'},
    {data: [], label: 'Violations'},
  ];



  public barChartLabelsByPeoLastShift = [];
  public barChartDataByPeoLastShift = [
    {data: [], label: 'Scans'},
    {data: [], label: 'Violations'},
  ];



  constructor(public excelExportDataService: ExcelExportDataService,
              public paymentDetailService: PaymentDetailSearchService,
              public toastrService: ToastrService,
              public organizationService: OrganizationService,
              public geofenceService: GeofenceService,
              public userService: UserService,
              public lprdataservice: LprDataService,
              public analyticsService: AnalyticsService,
              public authenticationService: AuthenticationService,
              public router: Router,
              private sanitizer:DomSanitizer,
              public tokenStorage: TokenStorage) { }


  ngOnInit() {
    this.userRole = this.tokenStorage.getRole();

    if(this.userRole == 'ROLE_SUPER_ADMIN'){
      this.getAllOrganizations();
    }
    else{
      let organizationId = this.tokenStorage.getOrganizationId();
      this.getOrganizationById(organizationId);
      this.getAllPeoByOrganization(organizationId, "all");
    }

    this.getAllGeofence();
    this.findAllSesionsData();
    // this.updateCharts();
  }


  getAllOrganizations() {
    this.organizationService.getAll()
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.allOrgsData = response.data;
        }
        else {
          this.toastrService.error(response.value,"Failed To Load Data!")
        }
      });
  }

  getOrganizationById(organizationId) {
    debugger
    this.organizationService.getOrganizationDetailById(organizationId)
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.allOrgsData.push(response.data);

          this.selectedOrgIdDaily = this.allOrgsData[0].id;
          this.selectedOrgIdMonthly = this.allOrgsData[0].id;
          this.selectedOrgIdAllGeofence = this.allOrgsData[0].id;
          this.selectedOrgIdByPeoLastShift = this.allOrgsData[0].id;
          this.selectedOrgIdMulti = this.allOrgsData[0].id;
          this.selectedOrgIdByLpn = this.allOrgsData[0].id;
        }
        else {
          this.toastrService.error(response.value,"Failed To Load Data!")
        }
      });
  }


  getAllGeofence() {
    this.geofenceService.getAll()
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.allGeofenceData = response.data;
        }
        else {
          this.toastrService.error(response.value,"Failed To Load Data!")
        }
      });
  }


  getAllPeoByOrganization(orgId: any, method: any) {
    this.userService.findUserOrganizations(orgId)
    .pipe(first())
    .subscribe(response => {
      if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
        this.allPeoUsers = response.data.filter((x) => x.roleName == "Patrolling Officer");
        if(method == "allGeofence"){
          this.peoDataByOrgForAllGeofence = this.allPeoUsers;
        }
        else if(method == "multi"){
          this.peoDataByOrgForMulti = this.allPeoUsers;
        }
        else if(method == "all"){
          this.peoDataByOrgForAllGeofence = this.allPeoUsers;
          this.peoDataByOrgForMulti = this.allPeoUsers;
        }
      } 
      else {
        this.toastrService.error(response.value, "Failed To Load Data!")
      }
    });
  }





  findAllSesionsData(): void {
    let payload = {
      "startTime": "01-01-" + this.currentYear,
      "endTime": "12-31-" + this.currentYear
    }

    this.lprdataservice.ShiftStatsDataAll(payload)
    .pipe(first())
    .subscribe(response => {
      if(response && response.code == WebConstants.STATUS.CODE_SUCCESS){
        this.allOrgsStatistics = response.data;
        this.chartData = this.allOrgsStatistics;
        this.updateCharts();
      } 
       else{
        this.toastrService.error(response.value, "Failed To Load Data!")
      }      
    })
  }


  getLogo(orgLogo: any){
    return this.sanitizer.bypassSecurityTrustResourceUrl(orgLogo);
  }
  

  exportPassportCSV() : void {

    this.paymentDetailService.getPassportData()
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.passportData = response.data;

          let dataForExcel = [];
          let count = 1;
          this.passportData.forEach((row: any) => {    
    
            row = row.data;
            let rowData = [count, row.numberPlate, row.startTime? String(new Date(row.startTime)):"",
                          row.endTime? String(new Date(row.endTime)):"", String(row.zoneNumber), row.zoneName, 
                          String(row.paymentSessionId), row.paymentServiceName, row.type, row.createdDate? String(new Date(row.createdDate)):""]
            dataForExcel.push(rowData);
            count++;
          });
        
          let reportData = {
            title: "PASSPORT DATA",
            data: dataForExcel,
            headers: ['S No.', 'License Plate', 'Start Time', 'End Time', 'Zone Number', 'Zone Name', 'Session ID', 'Service Name', 'Permit Type', 'Created Date']
          };
      
          this.excelExportDataService.exportExcel(reportData)

        } else {
          this.toastrService.error(response.value, response.data)
        }
      });

  }



  exportPaymentCSV() : void {

    this.paymentDetailService.getPaymentData()
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.paymentData = response.data;

          let dataForExcel = [];
          let count = 1;

          this.paymentData.forEach((row: any) => {
            row = row.data;
            let rowData = [count, row.numberPlate? row.numberPlate : row.lpn, row.startTime? String(new Date(row.startTime)):"",
                          row.endTime? String(new Date(row.endTime)):"", row.zoneNumber? row.zoneNumber:row.zoneName,
                          String(row.paymentSessionId), row.paymentServiceName, row.createdDate? String(new Date(row.createdDate)):""]
            dataForExcel.push(rowData);
            count++;
          });
        
          let reportData = {
            title: "PAYMENT DATA",
            data: dataForExcel,
            headers: ['S No.', 'License Plate', 'Start Time', 'End Time', 'Zone', 'Session ID', 'Service Name', 'Created Date']
          };
      
          this.excelExportDataService.exportExcel(reportData)

        } else {
          this.toastrService.error(response.value, response.data)
        }
      });

  }


  updateCharts(): void {
    // this.setValuesToChartScans();
    // this.setValuesToChartViolations();
    // this.chart.chart.update();
    this.createLineChartYearly();
  }


  // setValuesToChartScans(): void {
  //   this.barChartLabelsScans = [];
  //   this.barChartDataScans = [
  //     {data: [], label: 'Total Scans'}, 
  //   ];

  //   for(let i=0; i<this.chartData.length; i++){
  //     this.barChartLabelsScans[i] = this.chartData[i]['month'];
  //     this.barChartDataScans[0].data[i] = this.chartData[i]['totalScans'];
  //   }
  // }


  // setValuesToChartViolations(): void {
  //   this.barChartLabelsViolations = [];
  //   this.barChartDataViolations = [
  //     {data: [], label: 'Total Violations'}, 
  //   ];

  //   for(let i=0; i<this.chartData.length; i++){
  //     this.barChartLabelsViolations[i] = this.chartData[i]['month'];
  //     this.barChartDataViolations[0].data[i] = this.chartData[i]['totalViolation'];
  //   }
  // }



                                    // LINE CHART FOR YEARLY STATISTICS

  createLineChartYearly(){

    let scanData = [];
    let violationData = []
    let lableData = [];

    for(let i=0; i<this.chartData.length; i++){
      scanData[i] = this.chartData[i]['totalScans']
      violationData[i] = this.chartData[i]['totalViolation']
      lableData[i] = this.chartData[i]['month'];
    }
  
    this.chartLine = new Chart("lineChartYearly", {
      type: 'line', //this denotes tha type of chart

      data: {// values on X-Axis
        labels: lableData,

	       datasets: [
          {
            label: "Violation",
            data: violationData,
            backgroundColor: 'rgba(255,0,0,.5)',
            borderColor: 'rgb(75,10,125)',
            fill: true,
            lineTension: 0,
            radius: 5,
          },
          {
            label: "Scans",
            data: scanData,
            backgroundColor: 'rgba(0,0,255,.5)',
            borderColor: 'rgb(40,100,200)',
            fill: true,
            lineTension: 0.2,
            radius: 5,
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: true ,
        aspectRatio: 2.5,
        legend: {
          display: true,
          position: 'top',
          labels: {
            fontColor: '#999',
            fontSize: 14,
          },
        },
      }
      
    });
  }


  viewOrganizationDetails(orgId: any): void {
    this.router.navigate([WebConstants.WEB_URL.ORGANIZATION + "/organization-management"],{
      queryParams:{
        orgId: orgId
      },
      // skipLocationChange : true
    });
  }













  
                                      // BAR CHART FOR MONTHLY STATISTICS


  selectOrgMonthly(orgId): void{
    this.selectedOrgIdMonthly = orgId;
  }

  searchOrgDataMonthly(): void {

    if(!this.selectedOrgIdMonthly){
      this.toastrService.error("Please Select Organization", "Failed To Load Chart!")
      return;
    }
    
    this.findCurrentOrganizationDataMonthly({
      "startTime": this.selectedDateMonthly.start.format("MM-DD-YYYY"),
      "endTime": this.selectedDateMonthly.end.format("MM-DD-YYYY"),
      "orgId": this.selectedOrgIdMonthly
    });
  }


  findCurrentOrganizationDataMonthly(payload): void {
    this.lprdataservice.ShiftStatsDataMonthly(payload)
    .pipe(first())
    .subscribe(response => {
      debugger
      if(response && response.code == WebConstants.STATUS.CODE_SUCCESS){
        this.selectedOrgStatsDataMonthly = response.data;
        this.selectedOrgStatsDataMonthly.organization = this.allOrgsData.filter((element: any) => element.id == payload.organizationId);

        this.setNewValuesToChartMonthly();
      } 
       else{
        this.toastrService.error(response.value, "Failed To Load Data!")
      }      
    })
  }


  setNewValuesToChartMonthly(): void {
    this.barChartLabelsMonthly = [];
    this.barChartDataMonthly = [
      {data: [], label: 'Shifts'},
      {data: [], label: 'Scans'},
      {data: [], label: 'Permitted'},
      {data: [], label: 'Authorized'},
      {data: [], label: 'Expired'},
      {data: [], label: 'Unauthorized'},
      {data: [], label: 'Unpaid'} 
    ];

    this.chartData = this.selectedOrgStatsDataMonthly
    console.log(this.chartData);

    for(let i=0; i<this.chartData.length; i++){
      this.barChartLabelsMonthly[i] = this.chartData[i]['month'];

      this.barChartDataMonthly[0].data[i] = this.chartData[i]['totalShifts']
      this.barChartDataMonthly[1].data[i] = this.chartData[i]['totalScans']
      this.barChartDataMonthly[2].data[i] = this.chartData[i]['totalPermitted']
      this.barChartDataMonthly[3].data[i] = this.chartData[i]['totalAuthorized']
      this.barChartDataMonthly[4].data[i] = this.chartData[i]['totalExpired']
      this.barChartDataMonthly[5].data[i] = this.chartData[i]['totalUnauthorized']
      this.barChartDataMonthly[6].data[i] = this.chartData[i]['totalUnpaid']
    }
   
    this.chart.chart.update();
  }


  excelSheetDownloadMonthly(): void{

    if(!this.selectedOrgStatsDataMonthly){
      this.toastrService.error("No Data Found", "Failed To Export CSV!")
      return;
    }

    let dataForExcel = [];
  
    this.selectedOrgStatsDataMonthly.forEach((row: any) => {
      let rowData: any = [row.month, row.totalShifts, row.totalScans, row.totalPermitted, row.totalAuthorized, row.totalExpired, row.totalUnauthorized, row.totalUnpaid];
      dataForExcel.push(rowData);
    });

    let reportData = {
      title: "Monthly Shift Statistics",
      data: dataForExcel,
      headers: ['Date', 'Total Shifts', 'Total Scans', 'Total Permitted', 'Total Authorized', 'Total Expired', 'Total Unauthorized', 'Total Unpaid']
    };

    this.excelExportDataService.exportExcel(reportData)
  }


  downloadChartImageMonthly(event):void{

    if(!this.selectedOrgStatsDataMonthly){
      this.toastrService.error("No Data Found", "Failed To Export PNG!")
      return;
    }

    var anchor = event.target;
    let canvasElement = document.getElementsByTagName('canvas');
    anchor.href = canvasElement[1].toDataURL();
    anchor.download = "Monthly_Statistics.png";
  }











                                      // BAR CHART FOR DAILY STATISTICS


  findCurrentOrganizationDataDaily(payload): void {
    this.lprdataservice.ShiftStatsDataDaily(payload)
    .pipe(first())
    .subscribe(response => {
      if(response && response.code == WebConstants.STATUS.CODE_SUCCESS){
        this.selectedOrgStatsDataDaily = response.data;
        this.selectedOrgStatsDataDaily.organization = this.allOrgsData.filter((element: any) => element.id == payload.organizationId);
        this.setNewValuesToChartDaily();
      } 
       else{
        this.toastrService.error(response.value, "Failed To Load Data!")
      }      
    })
  }

  selectOrgDaily(orgId): void{
    this.selectedOrgIdDaily = orgId;
  }

  setNewValuesToChartDaily(): void {
    this.barChartLabelsDaily = [];
    this.barChartDataDaily = [
      {data: [], label: 'Shifts'},
      {data: [], label: 'Scans'},
      {data: [], label: 'Permitted'},
      {data: [], label: 'Authorized'},
      {data: [], label: 'Expired'},
      {data: [], label: 'Unauthorized'},
      {data: [], label: 'Unpaid'} 
    ];

    this.chartData = this.selectedOrgStatsDataDaily
    console.log(this.chartData);

    for(let i=0; i<this.chartData.length; i++){
      this.barChartLabelsDaily[i] = this.chartData[i]['month'];

      this.barChartDataDaily[0].data[i] = this.chartData[i]['totalShifts']
      this.barChartDataDaily[1].data[i] = this.chartData[i]['totalScans']
      this.barChartDataDaily[2].data[i] = this.chartData[i]['totalPermitted']
      this.barChartDataDaily[3].data[i] = this.chartData[i]['totalAuthorized']
      this.barChartDataDaily[4].data[i] = this.chartData[i]['totalExpired']
      this.barChartDataDaily[5].data[i] = this.chartData[i]['totalUnauthorized']
      this.barChartDataDaily[6].data[i] = this.chartData[i]['totalUnpaid']
    }
   
    this.chart.chart.update();
  }


  searchOrgDataDaily(): void {

    if(!this.selectedOrgIdDaily){
      this.toastrService.error("Please Select Organization", "Failed To Load Chart!")
      return;
    }
    
    this.findCurrentOrganizationDataDaily({
      "startTime": this.selectedDateDaily.start.format("MM-DD-YYYY"),
      "endTime": this.selectedDateDaily.end.format("MM-DD-YYYY"),
      "orgId": this.selectedOrgIdDaily
    });
  }


  excelSheetDownloadDaily(): void{

    if(!this.selectedOrgStatsDataDaily){
      this.toastrService.error("No Data Found", "Failed To Export CSV!")
      return;
    }

    let dataForExcel = [];
  
    this.selectedOrgStatsDataDaily.forEach((row: any) => {
      let rowData: any = [row.month, row.totalShifts, row.totalScans, row.totalPermitted, row.totalAuthorized, row.totalExpired, row.totalUnauthorized, row.totalUnpaid];
      dataForExcel.push(rowData);
    });

    let reportData = {
      title: "Daily Shift Statistics",
      data: dataForExcel,
      headers: ['Date', 'Total Shifts', 'Total Scans', 'Total Permitted', 'Total Authorized', 'Total Expired', 'Total Unauthorized', 'Total Unpaid']
    };

    this.excelExportDataService.exportExcel(reportData)
  }

  downloadChartImageDaily(event):void{

    if(!this.selectedOrgStatsDataDaily){
      this.toastrService.error("No Data Found", "Failed To Export PNG!")
      return;
    }

    var anchor = event.target;
    let canvasElement = document.getElementsByTagName('canvas')
    anchor.href = canvasElement[2].toDataURL();
    anchor.download = "Daily_Statistics.png";
  }
















                                      // BAR CHART FOR ALL GEOFENCE


  selectOrgAllGeofence(orgId): void{
    this.selectedOrgIdAllGeofence = orgId;
    this.getAllPeoByOrganization(orgId, "allGeofence");
  }

  selectPeoByAllGeofence(peoId){
    this.selectedPeoIdForAllGeofence = peoId;
  }

  searchOrgDataAllGeofence(): void {

    if(!this.selectedOrgIdAllGeofence){
      this.toastrService.error("Please Select Organization", "Failed To Load Chart!")
      return;
    }
    
    this.findCurrentOrganizationDataAllGeofence({
      "startTime": this.selectedDateAllGeofence.start.format("MM-DD-YYYY") + " 00:00:00",
      "endTime": this.selectedDateAllGeofence.end.format("MM-DD-YYYY") + " 23:59:59",
      "orgId": this.selectedOrgIdAllGeofence,
      "peoId": this.selectedPeoIdForAllGeofence,
    });
  }


  findCurrentOrganizationDataAllGeofence(payload): void {
    this.analyticsService.getViolationAnalyticsByAllGeofence(payload)
    .pipe(first())
    .subscribe(response => {
      debugger
      if(response && response.code == WebConstants.STATUS.CODE_SUCCESS){
        this.selectedOrgStatsDataAllGeofence = response.data;
        this.selectedOrgStatsDataAllGeofence.organization = this.allOrgsData.filter((element: any) => element.id == payload.orgId);
        this.setNewValuesToChartAllGeofence();
      } 
       else{
        this.toastrService.error(response.value, "Failed To Load Data!")
      }      
    })
  }


  setNewValuesToChartAllGeofence(): void {
    this.barChartLabelsAllGeofence = [];
    this.barChartDataAllGeofence = [
      {data: [], label: 'Shifts'},
      {data: [], label: 'Scans'},
      {data: [], label: 'Violations'},
    ];

    this.chartData = this.selectedOrgStatsDataAllGeofence
    console.log(this.chartData);

    for(let i=0; i<this.chartData.length; i++){
      this.barChartLabelsAllGeofence[i] = this.chartData[i]['geofenceName'];

      this.barChartDataAllGeofence[0].data[i] = this.chartData[i]['totalShifts']
      this.barChartDataAllGeofence[1].data[i] = this.chartData[i]['totalScan']
      this.barChartDataAllGeofence[2].data[i] = this.chartData[i]['violationCount']
    }
   
    this.chart.chart.update();
  }

  








                                      // BAR CHART FOR PEO LAST SHIFT


  selectOrgByPeoLastShift(orgId): void{
    this.selectedOrgIdByPeoLastShift = orgId;
  }

  searchOrgDataByPeoLastShift(): void {

    if(!this.selectedOrgIdByPeoLastShift){
      this.toastrService.error("Please Select Organization", "Failed To Load Chart!")
      return;
    }
    
    this.findCurrentOrganizationDataByPeoLastShift({
      "orgId": this.selectedOrgIdByPeoLastShift,
    });
  }


  findCurrentOrganizationDataByPeoLastShift(payload): void {
    this.analyticsService.getViolationAnalyticsByPeoLastShift(payload)
    .pipe(first())
    .subscribe(response => {
      debugger
      if(response && response.code == WebConstants.STATUS.CODE_SUCCESS){
        this.selectedOrgStatsDataByPeoLastShift = response.data;
        this.selectedOrgStatsDataByPeoLastShift.organization = this.allOrgsData.filter((element: any) => element.id == payload.orgId);
        this.setNewValuesToChartByPeoLastShift();
      } 
       else{
        this.toastrService.error(response.value, "Failed To Load Data!")
      }      
    })
  }


  setNewValuesToChartByPeoLastShift(): void {
    this.barChartLabelsByPeoLastShift = [];
    this.barChartDataByPeoLastShift = [
      {data: [], label: 'Scans'},
      {data: [], label: 'Violations'},
    ];

    this.chartData = this.selectedOrgStatsDataByPeoLastShift
    console.log(this.chartData);

    for(let i=0; i<this.chartData.length; i++){
      this.barChartLabelsByPeoLastShift[i] = this.chartData[i]['peoName'];

      this.barChartDataByPeoLastShift[0].data[i] = this.chartData[i]['totalScan']
      this.barChartDataByPeoLastShift[1].data[i] = this.chartData[i]['violationCount']
    }
   
    this.chart.chart.update();
  }












                                  // DOUGHNUT CHART FOR MULTI PARAMETERS 

  
  selectOrgMulti(orgId): void{
    this.selectedOrgIdMulti = orgId;
    this.getAllPeoByOrganization(orgId, "multi");
    this.peoDataByOrgForMulti = this.allPeoUsers;
  }

  selectGeofenceMulti(geofenceId): void{
    this.selectedGeofenceId = geofenceId;
  }

  selectPeoMulti(peoId){
    this.selectedPeoIdForMulti = peoId;
  }

  searchOrgDataMulti(): void {

    if(!this.selectedOrgIdMulti){
      this.toastrService.error("Please Select Organization", "Failed To Load Chart!")
      return;
    }
    
    this.findCurrentOrganizationDataMulti({
      "startTime": this.selectedDateMulti.start.format("MM-DD-YYYY") + " 00:00:00",
      "endTime": this.selectedDateMulti.end.format("MM-DD-YYYY") + " 23:59:59",
      "orgId": this.selectedOrgIdMulti,
      "peoId": this.selectedPeoIdForMulti,
      "geofenceId": this.selectedGeofenceId
    });
  }


  findCurrentOrganizationDataMulti(payload): void {
    this.analyticsService.getViolationAnalyticsByMulti(payload)
    .pipe(first())
    .subscribe(response => {
      debugger
      if(response && response.code == WebConstants.STATUS.CODE_SUCCESS){
        this.selectedOrgStatsDataMulti = response.data;
        this.selectedOrgStatsDataMulti.organization = this.allOrgsData.filter((element: any) => element.id == payload.orgId);
        this.createDonutChartMulti();
        // this.setNewValuesToChartMulti(); 
      } 
       else{
        this.toastrService.error(response.value, "Failed To Load Data!")
      }      
    })
  }


  createDonutChartMulti(){
    if(this.chartDonutMulti){
      this.chartDonutMulti.destroy();
    }

    this.chartDonutMulti = new Chart("multiDonutChart", {
      type: 'doughnut', //this denotes tha type of chart
      // type: 'polarArea', //this denotes tha type of chart

      data: {// values on X-Axis
        labels: ['Scans', 'Violations', 'Shifts'],
	      datasets: [{
          data: [
            this.selectedOrgStatsDataMulti? this.selectedOrgStatsDataMulti.totalScan:0,
            this.selectedOrgStatsDataMulti? this.selectedOrgStatsDataMulti.violationCount:0,
            this.selectedOrgStatsDataMulti? this.selectedOrgStatsDataMulti.totalShifts:0
          ],
          backgroundColor: [
            'blue',
            'red',
            'orange',
          ],
        }],
      },
      options: {
        aspectRatio:2.5
      }


      // options: {
      //   aspectRatio: 2.5,
      //   scale: {
      //     ticks: {
      //       display: false
      //     }
      //   },
      //   plugins: {
      //     title: {
      //       display: true,
      //       text: 'Area and Production of Important Crops (2020-21)',
      //       font: {
      //         size: 24,
      //         weight: 'bold',
      //         family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif"
      //       },
      //       padding: {
      //         top: 10,
      //         bottom: 30
      //       }
      //     },
      //     legend: {  
      //       display: true,
      //       labels: {
      //         font: {
      //           size: 14,
      //           family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif"
      //         }
      //       }
      //     }
      //   }
      // }

    });
  }

  // setNewValuesToChartMulti(): void {
  //   this.barChartDataMulti = [
  //     {data: [], label: 'Shifts'},
  //     {data: [], label: 'Scans'},
  //     {data: [], label: 'Violation'},
  //   ];

  //   this.chartData = []
  //   this.chartData.push(this.selectedOrgStatsDataMulti);
  //   console.log(this.chartData);

  //   for(let i=0; i<this.chartData.length; i++){
  //     this.barChartDataMulti[0].data[i] = this.chartData[i]['totalShifts']
  //     this.barChartDataMulti[1].data[i] = this.chartData[i]['totalScan']
  //     this.barChartDataMulti[2].data[i] = this.chartData[i]['violationCount']
  //   }
   
  //   this.chart.chart.update();
  // }









                                      // DOUGHNUT CHART FOR LPN


  selectOrgByLpn(orgId): void{
    this.selectedOrgIdByLpn = orgId;
  }

  searchOrgDataByLpn(): void {

    if(!this.selectedOrgIdByLpn){
      this.toastrService.error("Please Select Organization", "Failed To Load Chart!")
      return;
    }
    
    if(!this.licensePlate){
      this.toastrService.error("Please Enter License Plate", "Failed To Load Chart!")
      return;
    }

    this.findCurrentOrganizationDataByLpn({
      "startTime": this.selectedDateByLpn.start.format("MM-DD-YYYY") + " 00:00:00",
      "endTime": this.selectedDateByLpn.end.format("MM-DD-YYYY") + " 23:59:59",
      "orgId": this.selectedOrgIdByLpn,
      "lpn": this.licensePlate,
    });
  }


  findCurrentOrganizationDataByLpn(payload): void {
    this.analyticsService.getViolationAnalyticsByLicensePlate(payload)
    .pipe(first())
    .subscribe(response => {
      debugger
      if(response && response.code == WebConstants.STATUS.CODE_SUCCESS){
        this.selectedOrgStatsDataByLpn = response.data;
        this.selectedOrgStatsDataByLpn.organization = this.allOrgsData.filter((element: any) => element.id == payload.orgId);
        this.createDonutChartByLpn();
      } 
       else{
        this.toastrService.error(response.value, "Failed To Load Data!")
      }      
    })
  }


  createDonutChartByLpn(){
    if(this.chartDonutLpn){
      this.chartDonutLpn.destroy();
    }

    this.chartDonutLpn = new Chart("lpnDonutChart", {
      type: 'doughnut', //this denotes tha type of chart

      data: {// values on X-Axis
        labels: ['Violations', 'Scans'],
	      datasets: [{
          data: [
            this.selectedOrgStatsDataByLpn? this.selectedOrgStatsDataByLpn.totalViolation:0,
            this.selectedOrgStatsDataByLpn? this.selectedOrgStatsDataByLpn.totalScan:0
          ],
          backgroundColor: [
            'red',
            'blue',
          ],
        }],
      },
      options: {
        aspectRatio:2.5
      }

    });
  }











  downloadChartImageForAll(event, data, chartIndex, chartName):void{

    if(!data){
      this.toastrService.error("No Data Found", "Failed To Export PNG!")
      return;
    }

    var anchor = event.target;
    let canvasElement = document.getElementsByTagName('canvas')
    anchor.href = canvasElement[chartIndex].toDataURL();
    anchor.download = chartName  + " - " + data.organization[0].name + ".png";
  }



  excelSheetDownloadForAll(data, statisticName): void{

    if(!data){
      this.toastrService.error("No Data Found", "Failed To Export CSV!")
      return;
    }

    let dateRange: any;
    let header = [];
    let dataForExcel = [];

    if(statisticName == "Daily Statistics"){
      dateRange = this.selectedDateDaily.start.format("MM-DD-YYYY") + " - " + this.selectedDateDaily.end.format("MM-DD-YYYY");
      header = ['Date', 'Total Shifts', 'Total Scans', 'Total Permitted', 'Total Authorized', 'Total Expired', 'Total Unauthorized', 'Total Unpaid']
      data.forEach((row: any) => {
        let rowData: any = [row.month, row.totalShifts, row.totalScans, row.totalPermitted, row.totalAuthorized, row.totalExpired, row.totalUnauthorized, row.totalUnpaid];
        dataForExcel.push(rowData);
      });
    }
    else if(statisticName == "Monthly Statistics"){
      dateRange = this.selectedDateMonthly.start.format("MM-DD-YYYY") + " - " + this.selectedDateMonthly.end.format("MM-DD-YYYY");
      header = ['Date', 'Total Shifts', 'Total Scans', 'Total Permitted', 'Total Authorized', 'Total Expired', 'Total Unauthorized', 'Total Unpaid']
      data.forEach((row: any) => {
        let rowData: any = [row.month, row.totalShifts, row.totalScans, row.totalPermitted, row.totalAuthorized, row.totalExpired, row.totalUnauthorized, row.totalUnpaid];
        dataForExcel.push(rowData);
      });
    }
    else if(statisticName == "License Plate Statistics"){
      dateRange = this.selectedDateByLpn.start.format("MM-DD-YYYY") + " - " + this.selectedDateByLpn.end.format("MM-DD-YYYY");
      header = ['License Plate', 'Total Scans', 'Total Violation'];
      let rowData: any = [data.lpn, data.totalScan, data.totalViolation];
      dataForExcel.push(rowData);
    }
    else if(statisticName == "Multi Parameter Statistics"){
      dateRange = this.selectedDateMulti.start.format("MM-DD-YYYY") + " - " + this.selectedDateMulti.end.format("MM-DD-YYYY");
      header = ['Geofence', 'Total Shifts', 'Total Scans', 'Total Violation'];
      let rowData: any = [data.geofenceName, data.totalShifts, data.totalScan, data.violationCount];
      dataForExcel.push(rowData);
    }
    else if(statisticName == "All Geofence Statstics"){
      dateRange = this.selectedDateAllGeofence.start.format("MM-DD-YYYY") + " - " + this.selectedDateAllGeofence.end.format("MM-DD-YYYY");
      header = ['Geofence Name', 'Total Shifts', 'Total Scans', 'Total Violations'];
      data.forEach((row: any) => {
        let rowData: any = [row.geofenceName, row.totalShifts, row.totalScan, row.violationCount];
        dataForExcel.push(rowData);
      });
    }
    else if(statisticName == "PEO Last Shift Statistics"){
      header = ['PEO Name', 'Total Scans', 'Total Violations'];
      data.forEach((row: any) => {
        let rowData: any = [row.peoName, row.totalScan, row.violationCount];
        dataForExcel.push(rowData);
      });
    }
  
    let reportData = {
      title: statisticName + " - " + data.organization[0].name,
      data: dataForExcel,
      headers: header,
      dateRange: dateRange
    };

    this.excelExportDataService.exportExcel(reportData)
  }



}